
import rules, {
  maxLengthRule,
  minLengthRule,
  requiredRule,
} from "@/services/helpers/validation-rules";
import Vue from "vue";
import API from "@/api/API";
import store from "@/store";

export default Vue.extend({
  name: "enroll",

  data: () => ({
    rules,
    model: {} as any,
    id: null as number,
    selects: {
      studyPrograms: [] as Array<SelectComponentInterface>,
      specialities: [] as Array<SelectComponentInterface>,
      frequencyTypes: [] as any,
      studyTypes: [] as any,
    },
    availablePlacesList: [] as any,
    fullLoaded: false as boolean,
    errorMessages: {} as any,
    abiturientName: "" as string,
    places: {} as any,
    showNoPlaces: false as boolean,
  }),

  computed: {
    computedRules(): object {
      return {
        min: minLengthRule.bind(this),
        max: maxLengthRule.bind(this),
        required: requiredRule.bind(this),
      };
    },
    hasAvailablePlaces() {
      return !this.places.available_places;
    },
    frequency_type() {},
  },

  async beforeRouteEnter(to, from, next) {
    try {
      const studyPrograms = await API.studyPrograms().getList();

      next((vm) => {
        if (to.query.name) {
          vm.abiturientName = to.query.name;
        }

        vm.id = Number(to.params.id);
        vm.selects.studyPrograms = studyPrograms;
      });
    } catch (e) {
      await store.dispatch("alert/showError", e.message);
    }
  },

  methods: {
    clearData(list: boolean = false) {
      if (list) {
        this.model.speciality = null;
      }

      this.model.frequency_type = undefined;
      this.model.study_type = undefined;
      this.places = 0;
    },
    async getSpecialitiesList(): Promise<void> {
      this.clearData(true);

      try {
        this.selects.specialities = await this.$API.specialities().getList({
          study_program_id: this.model.study_program_id,
        });
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    async getFrequencyType(): Promise<void> {
      this.clearData();

      try {
        this.availablePlacesList = await this.$API
          .budgetPlaces()
          .getPlacesBySpeciality(this.model.speciality_id);
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }

      this.selects.frequencyTypes = [
        ...new Set(this.availablePlacesList.map((el: any) => el.frequency_type)),
      ];
    },
    getStudyType(): void {
        this.selects.studyTypes = [
          ...new Set(this.availablePlacesList.map((el: any) => el.study_type)),
        ];

      this.getAvailablePlaces();
    },
    async getAvailablePlaces(): Promise<void> {
      if (!this.model.study_type || !this.model.frequency_type) {
        return;
      }

      try {
        this.places = await this.$API
          .applicationRequests()
          .getAvailablePlaces(this.model);
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    async enroll(): Promise<void> {
      try {
        await this.$API.applicationRequests().enroll(this.id, this.model);
        await this.$router.push("/application_requests");
        await this.$store.dispatch(
          "alert/showSuccess",
          this.$t("global-alert.successful_enroll")
        );
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
  },
});
